var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data.item.owner_type.includes('DataSet'))?_c('div',[_c('span',[_vm._v("n/a")])]):_c('div',[_c('span',[_vm._v(" "+_vm._s(_vm.data.item.dirty_data_entry_count)+" / "+_vm._s(_vm.data.item.data_entry_count)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }